import React from 'react';
import useStyles from "../style";
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';

const InputSelectGroupType = ({ text, setValue, label, options, isEnable, isRequired }) => {
    const classes = useStyles();

    const handleChange = (e) => {
        const value = e.target.value;
        if (value != '') {
            var numberOfPersons = 0;
            var discount = 0;
            var indexPartner = 1;
            var isDiscountByPercent = false;

            options.map((option) => {
                if (option.name == value) {
                    numberOfPersons = option.numberOfPersons;
                    discount = parseFloat(option.discount);
                    isDiscountByPercent = option.isDiscountByPercent == 0 ? false : true;

                    for (var i = 0; i < numberOfPersons; i++) {
                        indexPartner = indexPartner + 1;
                    }
                }
            });

            setValue({
                ...text, text: value, numberOfPersons: numberOfPersons, discount: discount,
                valid: 'true', isDiscountByPercent: isDiscountByPercent
            });
        } else {
            setValue({
                ...text, text: value, numberOfPersons: 0, discount: 0, valid: 'false', isDiscountByPercent: false
            });
        }
    }

    return (
        <div>
            <div className={classes.divLabel}>
                <p className={classes.label} >{label}</p>
                {isRequired ? (
                    <p style={{ fontSize: 26, color: "#FF0000" }}>*</p>
                ) : (
                    <></>
                )}
            </div>
            <FormControl className={classes.formControlGroupType}>
                <Select
                    onChange={handleChange}
                    displayEmpty
                    disabled={isEnable ?? false}
                    value={text.text}
                    style={{color:"#FFFFFF"}}
                >
                    <MenuItem value=""> Selecciona </MenuItem>
                    {options.map((option) => (
                        <MenuItem value={option.name}>{option.name}</MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
}

export default InputSelectGroupType;
